import React, { Component } from 'react'
import PropTypes from 'prop-types'

class StatRollup extends Component {
  static propTypes = {
    isActive: PropTypes.bool,
    stat: PropTypes.number,
    format: PropTypes.object,
  }

  state = {
    rollup: 0,
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.isActive && !this.props.isActive) {
      this.iterate()
    }
  }

  iterate () {
    const rollup = this.state.rollup
    const stat = this.props.stat
    const remaining = stat - rollup
    const maxIterate = Math.min(
      Math.max(parseInt(stat / 100, 10), 1), // to prevent going too slow
      rollup * 8, // to prevent massive jumps
      remaining / 8,
    )
    const decelerateAt = 20

    const isDecelerating = remaining < decelerateAt
    const isAccelerating = isDecelerating ? false : rollup < 10
    const powerOf = isAccelerating ? rollup : isDecelerating ? (remaining / 3) : 0
    const speed = isAccelerating || isDecelerating ? 500 / Math.pow(1.618, powerOf) : 10

    const iterateBy = isAccelerating ? 1 : maxIterate

    const newRollup = Math.max(Math.min(rollup + iterateBy, stat - decelerateAt), rollup + 1)

    this.setState({
      rollup: newRollup > stat ? stat : newRollup,
    })

    if (newRollup >= stat) {
      return
    }

    setTimeout(() => this.iterate(), speed)
  }

  render () {
    const displayStat = this.state.rollup.toLocaleString(undefined, this.props.format)
    return (<span>{displayStat}</span>)
  }
}

export default StatRollup



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Card/StatRollup.jsx